export const setResources = (resources: any, serverReference: any) => {
    window.serverReference = serverReference;
    window.RESX = resources;
}